import baseApi from './base';
import { MyStudiesApiPort } from './myStudies';
import {
  companiesEndpoint,
  creatorsEndpoint,
  listStudiesEndpoint,
  MyStudiesEndpointsConfig,
  studiesStatusEndpoint,
} from './myStudiesEndpoints';

/**
 * Slice das 4 rotas GET da aba Meus Estudos do Flux Upload (`previvaz-arquivo/estudos/*`, backend
 * #80): as mesmas definições do Personalizado (`myStudiesEndpoints`), sob outro prefixo e com a tag
 * `Study` (a da lista legada do Upload, que `deleteStudy`/`cancelStudy`/`uploadStudies` já
 * invalidam). Nomes de endpoint próprios: `injectEndpoints` ignora um nome repetido. Sem rota de
 * cenários: o "bloco" do Upload é o caminho do zip.
 */
const CONFIG: MyStudiesEndpointsConfig = { root: 'produtos/previvaz-arquivo/estudos', listTag: 'Study' };

export const uploadMyStudiesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listUploadStudies: listStudiesEndpoint(build, CONFIG, 'listUploadStudies'),
    getUploadStudiesStatus: studiesStatusEndpoint(build, CONFIG, 'getUploadStudiesStatus'),
    listUploadStudyCompanies: companiesEndpoint(build, CONFIG, 'listUploadStudyCompanies'),
    listUploadStudyCreators: creatorsEndpoint(build, CONFIG, 'listUploadStudyCreators'),
  }),
});

export const {
  useListUploadStudiesQuery,
  useGetUploadStudiesStatusQuery,
  useListUploadStudyCompaniesQuery,
  useListUploadStudyCreatorsQuery,
} = uploadMyStudiesApi;

/** Port do Upload para a aba Meus Estudos (ver `MyStudiesApiPort` em `myStudies`). */
export const uploadMyStudiesApiPort: MyStudiesApiPort = {
  useListQuery: useListUploadStudiesQuery,
  useCompaniesQuery: useListUploadStudyCompaniesQuery,
  useCreatorsQuery: useListUploadStudyCreatorsQuery,
  useListQueryState: uploadMyStudiesApi.endpoints.listUploadStudies.useQueryState,
  initiateStatus: uploadMyStudiesApi.endpoints.getUploadStudiesStatus.initiate,
  updateList: (args, recipe) => uploadMyStudiesApi.util.updateQueryData('listUploadStudies', args, recipe),
  invalidateList: () => uploadMyStudiesApi.util.invalidateTags(['Study']),
};
